/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_News_To_RoadmapInputs */

const en_us2_community_news_to_roadmap = /** @type {(inputs: Community_News_To_RoadmapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See what's coming next`)
};

const pt_br2_community_news_to_roadmap = /** @type {(inputs: Community_News_To_RoadmapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver o que vem por aí`)
};

const es_419_community_news_to_roadmap = /** @type {(inputs: Community_News_To_RoadmapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver lo que viene`)
};

const pt_pt2_community_news_to_roadmap = /** @type {(inputs: Community_News_To_RoadmapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver o que aí vem`)
};

const fr_fr2_community_news_to_roadmap = /** @type {(inputs: Community_News_To_RoadmapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir ce qui arrive`)
};

const de_de2_community_news_to_roadmap = /** @type {(inputs: Community_News_To_RoadmapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sieh, was als Nächstes kommt`)
};

const it_it2_community_news_to_roadmap = /** @type {(inputs: Community_News_To_RoadmapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri cosa arriva`)
};

/**
* | output |
* | --- |
* | "See what's coming next" |
*
* @param {Community_News_To_RoadmapInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_news_to_roadmap = /** @type {((inputs?: Community_News_To_RoadmapInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_News_To_RoadmapInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_news_to_roadmap(inputs)
	if (locale === "es-419") return es_419_community_news_to_roadmap(inputs)
	if (locale === "pt-PT") return pt_pt2_community_news_to_roadmap(inputs)
	if (locale === "fr-FR") return fr_fr2_community_news_to_roadmap(inputs)
	if (locale === "de-DE") return de_de2_community_news_to_roadmap(inputs)
	if (locale === "it-IT") return it_it2_community_news_to_roadmap(inputs)
	return en_us2_community_news_to_roadmap(inputs)
});
export { community_news_to_roadmap as "community.news_to_roadmap" }